var _focused, _cleanup, _setup;
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
// src/focusManager.ts
import { Subscribable } from "./subscribable.js";
import { isServer } from "./utils.js";
var FocusManager = (_focused = /*#__PURE__*/new WeakMap(), _cleanup = /*#__PURE__*/new WeakMap(), _setup = /*#__PURE__*/new WeakMap(), class FocusManager extends Subscribable {
  constructor() {
    super();
    _classPrivateFieldInitSpec(this, _focused, void 0);
    _classPrivateFieldInitSpec(this, _cleanup, void 0);
    _classPrivateFieldInitSpec(this, _setup, void 0);
    _classPrivateFieldSet(_setup, this, onFocus => {
      if (!isServer && window.addEventListener) {
        const listener = () => onFocus();
        window.addEventListener("visibilitychange", listener, false);
        return () => {
          window.removeEventListener("visibilitychange", listener);
        };
      }
      return;
    });
  }
  onSubscribe() {
    if (!_classPrivateFieldGet(_cleanup, this)) {
      this.setEventListener(_classPrivateFieldGet(_setup, this));
    }
  }
  onUnsubscribe() {
    if (!this.hasListeners()) {
      var _classPrivateFieldGet2;
      (_classPrivateFieldGet2 = _classPrivateFieldGet(_cleanup, this)) === null || _classPrivateFieldGet2 === void 0 || _classPrivateFieldGet2.call(this);
      _classPrivateFieldSet(_cleanup, this, void 0);
    }
  }
  setEventListener(setup) {
    var _classPrivateFieldGet3;
    _classPrivateFieldSet(_setup, this, setup);
    (_classPrivateFieldGet3 = _classPrivateFieldGet(_cleanup, this)) === null || _classPrivateFieldGet3 === void 0 || _classPrivateFieldGet3.call(this);
    _classPrivateFieldSet(_cleanup, this, setup(focused => {
      if (typeof focused === "boolean") {
        this.setFocused(focused);
      } else {
        this.onFocus();
      }
    }));
  }
  setFocused(focused) {
    const changed = _classPrivateFieldGet(_focused, this) !== focused;
    if (changed) {
      _classPrivateFieldSet(_focused, this, focused);
      this.onFocus();
    }
  }
  onFocus() {
    const isFocused = this.isFocused();
    this.listeners.forEach(listener => {
      listener(isFocused);
    });
  }
  isFocused() {
    var _globalThis$document;
    if (typeof _classPrivateFieldGet(_focused, this) === "boolean") {
      return _classPrivateFieldGet(_focused, this);
    }
    return ((_globalThis$document = globalThis.document) === null || _globalThis$document === void 0 ? void 0 : _globalThis$document.visibilityState) !== "hidden";
  }
});
var focusManager = new FocusManager();
export { FocusManager, focusManager };